var _Button$defaultProps;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useContext, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { ThemeContext, ThemeProvider } from "styled-components";
import { Primary } from "./variants/Primary";
import { Secondary } from "./variants/Secondary";
import { Stripped } from "./variants/Stripped";
import { Tertiary } from "./variants/Tertiary";

var getComponent = function getComponent(variant) {
  if (variant === "primary") return Primary;
  if (variant === "secondary") return Secondary;
  if (variant === "tertiary") return Tertiary;
  if (variant === "stripped") return Stripped;
};

export var Button = React.forwardRef(function (props, ref) {
  var theme = useContext(ThemeContext);
  var variant = props.variant,
      disabled = props.disabled,
      loading = props.loading;


  var noHoverAnimation = disabled || loading || variant === "stripped";

  var Component = getComponent(variant);

  return React.createElement(
    ThemeProvider,
    {
      theme: _extends({}, theme, {
        primary: disabled ? "#e7e7e7" : theme.primary,
        background: disabled ? "#e7e7e7" : theme.background,
        textNegative: disabled ? "#7e7e7e" : theme.textNegative
      })
    },
    React.createElement(Component, _extends({
      noHoverAnimation: noHoverAnimation,
      forwardedRefSafe: ref
    }, props))
  );
});

Button.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary", "stripped"]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  compact: PropTypes.bool,
  loading: PropTypes.bool,
  fluid: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.bool)]),
  m: PropTypes.string
} : {};

Button.defaultProps = (_Button$defaultProps = {
  variant: "primary",
  disabled: false,
  loading: false,
  compact: false
}, _Button$defaultProps["loading"] = false, _Button$defaultProps.fluid = false, _Button$defaultProps.m = null, _Button$defaultProps);